import { render, staticRenderFns } from "./ConsumeRecord.vue?vue&type=template&id=461a4415&scoped=true"
import script from "./ConsumeRecord.vue?vue&type=script&lang=js"
export * from "./ConsumeRecord.vue?vue&type=script&lang=js"
import style0 from "./ConsumeRecord.vue?vue&type=style&index=0&id=461a4415&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461a4415",
  null
  
)

export default component.exports